const initSlide = () => {
    
    const slickInstance = $(".slide-vertical-menu-service .service-slick").slick({
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        adaptiveHeight: true,
        centerMode: true,
        vertical: true,
        verticalSwiping: false,
        arrows: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    autoplay: false,
                    vertical: false,
                    verticalSwiping: false,
                    centerMode: false,
                    arrows: true,
                }
            },
        ]
    });

    $(".slide-vertical-menu-service .service-slick-title").on("click", ".title-item", function () {

        const $parent = $(this).parent(".service-slick-title");
        $parent.find(".active").removeClass("active");
        $(this).addClass("active")

        const index = $(this).index()
        slickInstance.slick('slickGoTo', index);

    })
}

module.exports = initSlide